import {useEffect, useRef, useState} from "react";
import * as Track from "@qoohoo/common/utils/analytics/track";
import {button, link, pageview} from "@qoohoo/common/constants/analytics";
import Spinner from "@qoohoo/common/library/loader/Spinner";
import JoinTelegramButton from "../telegram/JoinTelegramButton";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import {openInNewTab} from "@qoohoo/common/utils/url";

export function checkIfExistingMemberOfChannel(membershipStartDT) {
    let _isExistingMemberOfChannel;

    const memberFirstJoinedAt = new Date(membershipStartDT ?? Date()).getTime();
    const currentTS = new Date().getTime();

    // Note: Ideally, we have at least 5 days gap for doing advance payment if user is doing. So, if the join date
    // within 15min, that means it's current payment only
    const isFirstTimeMemberOfChannel = (currentTS - memberFirstJoinedAt) < 15 * 60 * 1000; // 15min delta

    _isExistingMemberOfChannel = !isFirstTimeMemberOfChannel;

    return _isExistingMemberOfChannel;
}

export default function JoinTelegramModal({
  channelDetails,
  userChannelDetail,
  closeModal,
  isLoading,
  customSettings
}) {
  const container = useRef(null);

  const modal_name = "thank_you_modal";
  const trackDetails = {
    current_screen: pageview.channel_details,
    modal_name,
    is_paid: true,
    uid: channelDetails.uid,
    name: channelDetails.name,
    type: channelDetails.type,
    recurring_type: channelDetails?.plans?.[0]?.plan_type,
    "creator.uid": channelDetails.creator.uid,
    "creator.full_name": channelDetails.creator.fullname,
    "creator.username": channelDetails.creator.username,
    is_telegram: true,
  };

  function handleCloseModal() {
    closeModal();

    Track.buttonClick(button.thank_you, trackDetails);
  }

  function handleJoinTelegramButtonClick () {
    window.open(userChannelDetail.telegram.invite_link, "_blank");
    Track.linkClick(link.join_on_telegram_link, trackDetails);
  }

  useEffect(() => {
    Track.customEvent(modal_name, {
      actionType: "modal_open",
      label: modal_name,
      ...trackDetails,
    });

    if (customSettings?.redirection_on_success) {
      openInNewTab(customSettings.redirection_on_success, 1250);
    }

  }, []);

  let heading = 'Invite link', content, actionButton;

  if (isLoading) {
    content = (
      <div>
        Please wait...
        <div className="mt-8 flex items-center justify-center">
          <Spinner size="md" />
        </div>
      </div>
    )
  } else {
    const isExistingMemberOfChannel = checkIfExistingMemberOfChannel(userChannelDetail.membership_period_start);

    const isInviteLinkReady = userChannelDetail.telegram?.invite_link;

    if (isInviteLinkReady && !isExistingMemberOfChannel) {

      content = "Your payment is successful, join on Telegram from here.";

      actionButton = (
        <div className="relative px-5 sm:px-0 py-3 sm:py-0 bg-transparent text-center mt-6 z-[1]">
        <button
          className="py-[14px] relative mb-3 sm:mb-0 w-full font-bold sm:w-80 bg-gradient-to-t from-[#229ED9] to-[#2AABEE] rounded-full outline-none focus:outline-none"
          onClick={handleJoinTelegramButtonClick}
        >
          Join on Telegram
        </button>
          <CopyToClipboard
            text={userChannelDetail.telegram?.invite_link}
            onCopy={() => {
              toast.success("Sharable link copied!");

              Track.buttonClick(button.copy_link, {
                ...trackDetails,
                link: userChannelDetail.telegram?.invite_link,
              });
            }}
          >
            <div className="mx-auto mt-6 cursor-pointer flex justify-center items-center hover:opacity-90">
              <span className="leading-[150%px] font-semibold text-[#58A6EE]">
                Copy invite link
              </span>
              <img
                src="/assets/icons/link-blue.svg"
                alt=""
                className="ml-2.5"
              />
            </div>
          </CopyToClipboard>
        </div>
      );

    } else if (isExistingMemberOfChannel) {
      heading = 'Congratulations!'
      content = 'Your membership is renewed 🎉';
      actionButton = (
        <button
          className="py-[14px] relative max-w-[136px] mt-6 mb-3 sm:mb-0 w-full font-bold sm:w-80 bg-gradient-to-t from-[#229ED9] to-[#2AABEE] rounded-full outline-none focus:outline-none"
          onClick={handleCloseModal}
        >
          Ok, thanks
        </button>
      );
    } else {
      content = 'We’ll send you the invite link to join Telegram on SMS. In some cases, it may take upto 2 hours.';
      actionButton = (
        <button
          className="py-[14px] relative max-w-[136px] mt-6 mb-3 sm:mb-0 w-full font-bold sm:w-80 bg-gradient-to-t from-[#229ED9] to-[#2AABEE] rounded-full outline-none focus:outline-none"
          onClick={handleCloseModal}
        >
          Ok, thanks
        </button>
      );
    }
  }

  const onPaymentSuccessRedirection = customSettings?.redirection_on_success && (
    <p className="my-6 text-white text-base font-bold">
      Redirecting...
    </p>
  );

  return (
    <>
      <div className="absolute left-0 right-0 mx-auto sm:-top-40 -top-48 z-[1] pointer-events-none">
        <div className="container pointer-events-none" ref={container}></div>
      </div>
      <div className="mt-2 text-4xl leading-8 font-bold dark:text-[#16191B]">{heading}</div>
      <div className="text-base leading-[150%] font-light text-[#F0F0F0] mt-5 dark:text-[#16191B]">
        {content}
        {onPaymentSuccessRedirection}
      </div>
      {actionButton}
    </>
  );
}
